import CreatableSelect from "react-select/creatable";

import TagIcon from "@/assets/icons/tag.svg";
import { cx } from "@/utils";
import TextButton from "@components/TextButton";

import styles from "./TagSelector.module.css";

// We don't want these components to render at all
const DropdownIndicator = () => {
  return null;
};

// We don't want these components to render at all
// Options are displayed alongside the input. Not inside of it as react-selects wants to
const MultiValueContainer = () => {
  return null;
};

const Input = ({
  className,
  autoComplete,
  value,
  onChange,
  isDisabled,
  innerRef,
  onFocus,
  onBlur,
}) => {
  return (
    <TextButton className={cx(styles.root, className)} icon={TagIcon}>
      <input
        className={styles.input}
        placeholder={L.MENTIONS_TAGS_TITLE}
        autoComplete={autoComplete}
        value={value}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        disabled={isDisabled}
        ref={innerRef}
      />
    </TextButton>
  );
};

const customStyles = {
  control: (provided) => ({
    ...provided,
    backgroundColor: "transparent !important",
    minHeight: "auto !important",
    height: "100%",
    border: 0,
    boxShadow: 0,
  }),
};

export const TagSelector = (props) => {
  return (
    <CreatableSelect
      {...props}
      isMulti
      openMenuOnClick={true}
      classNamePrefix="react-select"
      isClearable={false}
      isValidNewOption={(v) => Boolean(v)}
      styles={customStyles}
      noOptionsMessage={() => L.MENTIONS_TAGS_NO_OPTIONS}
      formatCreateLabel={(v) => `${L.MENTIONS_TAGS_CREATE_NEW} ”${v}”`}
      createOptionPosition="first"
      placeholder=""
      components={{
        Input,
        MultiValueContainer,
        DropdownIndicator,
      }}
    />
  );
};
